// PAYROLL-FINAL-B2 — shared Employee Number input + error mapping.
import { Input } from "@/components/ui/input";

export const EMPLOYEE_NUMBER_TAKEN_MESSAGE =
    "This employee number is already used by another employee "
    + "in your company.";

export function isEmployeeNumberTaken(err) {
    return err?.response?.status === 409
        && err?.response?.data?.detail?.code === "EMPLOYEE_NUMBER_TAKEN";
}

export function EmployeeNumberInput({ value, onChange, disabled, testId }) {
    return (
        <label className="block text-sm">
            <span className="text-neutral-700">
                Employee Number{" "}
                <span className="text-neutral-400">(optional)</span>
            </span>
            <Input
                data-testid={testId}
                value={value}
                maxLength={32}
                inputMode="text"
                autoComplete="off"
                placeholder="e.g. 00452"
                onChange={(e) => onChange(e.target.value)}
                disabled={disabled}
            />
        </label>
    );
}
